<template>
  <div>
    <div class="top">
      <Header :moduleTitle="moduleTitle" ref="header">
        <template slot="searchBox">
          <Search @search="searchList" ref="search"></Search>
        </template>
      </Header>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header"
import Search from "@/components/SearchTwo"


export default {
  props: {
    trackType: String,
    moduleTitle: String,
    defaultTableColAttrs: Array
  },
  components: {
    Header,
    Search,
  },
  data () {
    return {
    }
  },
  mounted () {

  },
  methods: {
    searchList (val) {
      this.$emit('search', val)
    },
    getRowKeys () {

    },
    getAccount(){
      this.$refs.header.getAccount()
    },
    resetForm(){
      this.$refs.search.resetForm()
    }
  }
};
</script>
<style scoped lang="less">
</style>